import classNames from "../../utility/classNames";

const getColorClasses = (color) => {
  switch (color) {
    case "gray":
      return "bg-ink-700 hover:bg-ink-900 focus-visible:outline-ink-700 text-cream-50";
    case "red":
      return "bg-signal-red-500 hover:bg-signal-red-600 focus-visible:outline-signal-red-500 text-white";
    case "light-red":
      return "bg-signal-red-50 hover:bg-signal-red-100 focus-visible:outline-signal-red-100 text-signal-red-700 ring-1 ring-inset ring-signal-red-100";
    case "green":
      return "bg-signal-green-500 hover:bg-signal-green-600 focus-visible:outline-signal-green-500 text-white";
    case "light-green":
      return "bg-signal-green-50 hover:bg-signal-green-100 focus-visible:outline-signal-green-100 text-accent-700 ring-1 ring-inset ring-signal-green-100";
    case "blue":
    case "indigo":
      return "bg-accent-500 hover:bg-accent-600 focus-visible:outline-accent-500 text-cream-50";
    case "amber":
      return "bg-signal-amber-500 hover:bg-signal-amber-600 focus-visible:outline-signal-amber-500 text-white";
    case "white":
      return "bg-white text-ink-900 ring-1 ring-inset ring-ink-200 hover:bg-cream-100 shadow-hairline";
    default:
      return "bg-accent-500 hover:bg-accent-600 focus-visible:outline-accent-500 text-cream-50";
  }
};

const PrimaryButton = ({
  children,
  onClick,
  colour = "blue",
  className = "",
  type = "button",
  disabled = false,
  ...props
}) => {
  const colorClasses = getColorClasses(colour);
  const disabledClasses = disabled ? "opacity-50 cursor-not-allowed" : "";

  const style = classNames(
    colorClasses,
    disabledClasses,
    "inline-flex items-center justify-center rounded-pill px-4 py-2 text-center text-sm font-medium tracking-[-0.005em]",
    "focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2",
    "transition-[background-color,transform] duration-150 ease-editorial",
    !disabled && "active:scale-[0.98]",
    className
  );

  return (
    <button
      onClick={onClick}
      type={type}
      className={style}
      disabled={disabled}
      {...props}
    >
      {children}
    </button>
  );
};

export default PrimaryButton;
